import * as React from 'react';
import { Box } from '@mui/material';
import IdleTimer from '../IdleTimer';
import Drawer from '../../ui/drawer/Drawer';

type PropsWithChildren<P> = P & { children?: React.ReactNode };

type IProps = PropsWithChildren<{}>;

const Layout = (props: IProps) => {
  const [hasBlockingNotifications, setHasBlockingNotifications] = React.useState(true);

  return (
    <Box display='flex'
      flexDirection='row'
      sx={{
        marginTop: {
          xs: '56px',
          md: 0,
        },
        maxWidth: '100%',
        minWidth: '100%',
        width: '100%',
      }}
    >
      <Drawer onBlockingStateChange={setHasBlockingNotifications} />
      <Box
        sx={{
          maxWidth: { xs: '100%' },
          width: { xs: '100%' },
          pointerEvents: hasBlockingNotifications ? 'none' : 'auto',
        }}
        aria-hidden={hasBlockingNotifications}
        {...(hasBlockingNotifications ? { inert: '' } : {})}
      >
        <Box sx={{ maxWidth: '100%', overflow: 'hidden' }}>{props.children}</Box>
      </Box>
      <IdleTimer />
    </Box>
  );
};

export default Layout;
